import React, { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import QicAuthorizer from './components/QicAuthorizer';

// Lazy load QIC pages
const ListPromptsPage = lazy(() => import('./pages/prompts/ListPromptPage'));
const CreatePromptPage = lazy(() => import('./pages/prompts/CreatePromptPage'));
const EditPromptPage = lazy(() => import('./pages/prompts/EditPromptPage'));
const ComparePromptVersionsPage = lazy(() => import('./pages/prompts/ComparePromptPage'));

const ListAiAgentsPage = lazy(() => import('./pages/agents/ListAgentPage'));
const EditAiAgentPage = lazy(() => import('./pages/agents/EditAgentPage'));
const CreateAiAgentPage = lazy(() => import('./pages/agents/CreateAgentPage'));
const TestAiAgentPage = lazy(() => import('./pages/agents/TestAgentPage'));

const ListKnowledgeBasesPage = lazy(() => import('./pages/knowledge-bases/ListKnowledgeBasePage'));
const CreateKnowledgeBasePage = lazy(() => import('./pages/knowledge-bases/CreateKnowledgeBasePage'));
//const EditKnowledgeBasePage = lazy(() => import('./pages/knowledge-bases/EditKnowledgeBasePage'));

const routes: RouteObject[] = [
  {
    element: <QicAuthorizer />,
    children: [
      {
        path: 'portal/qic',
        element: <Navigate to='/portal' replace />
      },
      // Prompts routes
      {
        path: '/portal/qic/prompts',
        element: <ListPromptsPage />
      },
      {
        path: '/portal/qic/prompts/create',
        element: <CreatePromptPage />
      },
      {
        path: '/portal/qic/prompts/:promptId',
        element: <EditPromptPage />
      },
      {
        path: '/portal/qic/prompts/compare/:promptId',
        element: <ComparePromptVersionsPage />
      },

      // Agents routes
      {
        path: '/portal/qic/agents',
        element: <ListAiAgentsPage />
      },
      {
        path: '/portal/qic/agents/create',
        element: <CreateAiAgentPage />
      },
      {
        path: '/portal/qic/agents/:agentId',
        element: <EditAiAgentPage />
      },
      {
        path: '/portal/qic/agents/test/:agentId',
        element: <TestAiAgentPage />
      },

      // Knowledge bases routes
      {
        path: '/portal/qic/knowledge-bases',
        element: <ListKnowledgeBasesPage />
      },
      {
        path: '/portal/qic/knowledge-bases/create',
        element: <CreateKnowledgeBasePage />
      }
      /*{
        path: '/portal/qic/knowledge-bases/:kbId',
        element: <EditKnowledgeBasePage />
      }*/
    ]
  }
];

export default routes;
